export default interface ISchedule {
    monday: number;
    tuesday: number;
    wednesday: number;
    thursday: number;
    friday: number;
    saturday: number;
    sunday: number;
}

export interface ILocalSchedule {
    opening: ISchedule;
    closing: ISchedule;
}

export const maxTicks: number = 863999990000;

export const defaultOpeningSchedule: ISchedule = {
    monday: 0,
    tuesday: 0,
    wednesday: 0,
    thursday: 0,
    friday: 0,
    saturday: 0,
    sunday: 0,
};

export const defaultClosingSchedule: ISchedule = {
    monday: maxTicks,
    tuesday: maxTicks,
    wednesday: maxTicks,
    thursday: maxTicks,
    friday: maxTicks,
    saturday: maxTicks,
    sunday: maxTicks,
};
